import React, { useState } from 'react';
import { 
  FaImages, FaSearchPlus, FaShieldAlt, FaCheckCircle, 
  FaChevronDown, FaTimes, FaCamera, FaBuilding 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const ImageGallery = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);
  // State for Lightbox Modal
  const [activeImage, setActiveImage] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const galleryImages = [
    {
      src: "/images/aboutus.jpg",
      title: "Executive Client Consultation",
      category: "Advisory & Meetings",
      description: "Our advisors conducting one-on-one wealth management and tax strategy sessions at our Hyderabad office."
    },
    {
      src: "/images/goal-based-investments.jpg",
      title: "Global Market & Portfolio Review",
      category: "Portfolio Management",
      description: "Real-time tracking and strategic reallocation sessions for cross-border investments and alternative asset classes."
    },
    {
      src: "/images/corporate-financial-wellness.jpg",
      title: "Corporate Financial Wellness Workshop",
      category: "Corporate Wellness",
      description: "Interactive employee financial literacy seminar focusing on tax planning, budgeting, and retirement security."
    },
    {
      src: "/images/estate-planning.jpg",
      title: "Estate & Family Trust Structuring",
      category: "Succession Planning",
      description: "Confidential consultations with legal and financial experts for private family trust setup and multi-generational wealth transfer."
    },
    {
      src: "/images/alternate-investments.jpg",
      title: "Alternative Investment Fund Briefing",
      category: "Alternative Assets",
      description: "Institutional due diligence and private equity deal sourcing sessions for high-net-worth investors."
    },
    {
      src: "/images/wealth-management.jpg",
      title: "Annual Wealth Strategy Summit",
      category: "Events & Conferences",
      description: "Bringing together industry experts, clients, and partners to discuss economic trends and long-term asset growth."
    }
  ];

  const faqs = [
    {
      q: "Where are Lotoswealth's offices located?",
      a: "Our primary headquarters and advisory offices are located in Hyderabad, Telangana, where we host our clients for personal consultations, tax reviews, and wealth strategy sessions."
    },
    {
      q: "Can I schedule an in-person meeting at your office?",
      a: "Yes! We welcome clients to book an in-person consultation at our office. You can schedule an appointment using any of the consultation buttons across our website."
    },
    {
      q: "Do you host virtual meetings for clients outside Hyderabad or NRIs?",
      a: "Absolutely. While our gallery showcases our physical office and workshop environments, a significant portion of our advisory services are conducted via secure virtual video conferencing for NRIs and clients across India and globally."
    },
    {
      q: "How can I view high-resolution event photos or workshop materials?",
      a: "All workshop slide decks, event photographs, and masterclass media kits are shared directly with registered attendees and corporate partners via our secure client portal."
    }
  ];

  return (
    <main className="image-gallery-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Image Gallery | Wealth Management & Financial Services Photos | Lotoswealth</title>

  <meta
    name="description"
    content="Explore the Lotoswealth Image Gallery featuring Wealth Management, Portfolio Management Services (PMS), Financial Planning, Mutual Funds, Stock Investments, Tax Planning, Retirement Planning, Home Loans, Car Loans, Education Loans, corporate events, client meetings, and financial advisory services in Hyderabad."
  />

  <meta
    name="keywords"
    content="Image Gallery Hyderabad, Lotoswealth Gallery, Wealth Management Images Hyderabad, Financial Services Gallery Hyderabad, Portfolio Management Images Hyderabad, PMS Hyderabad, Financial Planning Images Hyderabad, Mutual Funds Images Hyderabad, Stock Market Images Hyderabad, Investment Gallery Hyderabad, Tax Planning Images Hyderabad, Retirement Planning Images Hyderabad, Estate Planning Images Hyderabad, Home Loan Images Hyderabad, Car Loan Images Hyderabad, Education Loan Images Hyderabad, Corporate Events Hyderabad, Financial Advisor Hyderabad, Wealth Advisor Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/image-gallery"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/image-gallery"
  />
  <meta
    property="og:title"
    content="Image Gallery | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Browse the Lotoswealth Image Gallery showcasing Wealth Management, Investment Advisory, Portfolio Management, Mutual Funds, Loans, financial events, and client success stories."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Image Gallery | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Explore our Image Gallery featuring Wealth Management, Financial Planning, Portfolio Management, Mutual Funds, Stock Investments, Loans, and corporate financial events in Hyderabad."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/image-gallery.jpg" 
            alt="Lotoswealth Image Gallery" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Image Gallery & Moments
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            A Visual Journey Through Our Advisory, Workshops, and Client Interactions
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth's Visual Gallery. Beyond spreadsheets, portfolios, and tax filings, our work is built on human connections, trusted relationships, and engaging corporate environments. 
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Take a visual look inside our executive consultation rooms, corporate financial wellness workshops, team strategy sessions, and client summits held in Hyderabad and across India.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Explore our gallery and experience the professional atmosphere that drives our commitment to your financial success.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY OUR ENVIRONMENT MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                An Environment Built on Trust and Confidentiality
              </h2>
              <p className="text-muted line-height-lg">
                Managing wealth, estate plans, and corporate taxes requires an environment of absolute privacy, comfort, and professional rigor. Our physical and virtual spaces are meticulously designed to foster deep, meaningful discussions about your financial future.
              </p>
              <p className="text-muted line-height-lg">
                From high-engagement corporate wellness seminars to private one-on-one advisory suites, every interaction at Lotoswealth reflects our core commitment to excellence, transparency, and personalized care.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">The Lotoswealth Experience</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Private Consultation Suites:</strong> Secure, confidential advisory rooms.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Interactive Workshops:</strong> Engaging corporate financial literacy setups.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>State-of-the-Art Infrastructure:</strong> Advanced research and portfolio tracking desks.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Client-Centric Focus:</strong> Welcoming spaces designed for comfortable collaboration.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. IMAGE GALLERY GRID (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">📸 Gallery Highlights</h2>
            <p className="text-white">Click any image to view details in full screen.</p>
          </div>

          <div className="row g-4">
            
            {galleryImages.map((image, index) => (
              <div key={index} className="col-lg-4 col-md-6 animate-slide-up delay-1">
                <div 
                  className="bg-light rounded-4 overflow-hidden h-100 hover-lift-card border-bottom border-teal border-4 shadow-sm position-relative"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setActiveImage(image)}
                >
                  <div className="position-relative overflow-hidden" style={{ height: '240px' }}>
                    <img 
                      src={image.src} 
                      alt={image.title} 
                      className="w-100 h-100 object-fit-cover transition-transform hover-zoom"
                    />
                    <div className="position-absolute top-0 start-0 m-3">
                      <span className="badge bg-teal text-white px-3 py-2 small">{image.category}</span>
                    </div>
                    <div className="position-absolute bottom-0 end-0 m-3 bg-dark bg-opacity-75 text-white p-2 rounded-circle">
                      <FaSearchPlus size={14} />
                    </div>
                  </div>
                  <div className="p-4">
                    <h5 className="fw-bold mb-2 text-dark">{image.title}</h5>
                    <p className="text-muted small mb-0">{image.description}</p>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* =========================================
          4. GALLERY CATEGORIES (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Explore Gallery Categories</h2>
            <p className="text-light opacity-75">A glimpse into our diverse operational environments.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Advisory & Client Meetings</h5>
                <p className="small text-muted mb-0">Private one-on-one sessions addressing tax planning, asset allocation, and wealth management strategies.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Corporate Wellness Seminars</h5>
                <p className="small text-muted mb-0">Engaging financial literacy workshops conducted across enterprise offices to reduce employee stress.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Research & Portfolio Desks</h5>
                <p className="small text-muted mb-0">Our analytical teams evaluating equities, alternative investments, private equity deals, and global markets.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Succession & Trust Structuring</h5>
                <p className="small text-muted mb-0">Delicate, confidential family office and estate planning meetings ensuring seamless generational wealth transfer.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Events & Client Summits</h5>
                <p className="small text-muted mb-0">Gatherings of high-net-worth clients, entrepreneurs, and industry leaders discussing long-term financial growth.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Visits Our Offices?</h3>
              <p className="text-muted small mb-4">Our welcoming spaces host a wide variety of esteemed clients:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Ultra-HNIs & Family Offices",
                  "Corporate Executives & Founders", "Salaried Professionals",
                  "Corporate HR & Wellness Teams", "NRIs Visiting Hyderabad",
                  "Retirees & Senior Citizens", "Long-Term Partners & Clients"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Experience Lotoswealth in Person?</h3>
                <p className="text-muted small mb-4">While digital meetings are convenient, visiting our advisory headquarters offers a distinct advantage. Clients choose to meet us because we provide:</p>
                <div className="row g-3">
                  {[
                    "Private, Secure Consultation Rooms", "Direct Face-to-Face Expert Guidance",
                    "Personalized Wealth & Tax Reviews", "Welcoming & Professional Atmosphere",
                    "Comprehensive Portfolio Dashboards", "Dedicated Relationship Support",
                    "Confidential Data Handling", "Holistic Financial Consultations"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding our Offices & Consultations</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Visit Us or Schedule a Consultation?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Experience personalized wealth advisory in person at our Hyderabad office or via secure video conference. Connect with us today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule a Consultation Today
          </button>
        </div>
      </section>

      {/* =========================================
          8. LIGHTBOX MODAL POPUP
      ========================================= */}
      {activeImage && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 z-5 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center p-3"
          style={{ zIndex: 1050 }}
          onClick={() => setActiveImage(null)}
        >
          <div 
            className="bg-white rounded-4 overflow-hidden shadow-lg position-relative w-100"
            style={{ maxWidth: '750px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="position-absolute top-0 end-0 m-3 btn btn-dark rounded-circle p-2 lh-1 text-white border-0 z-3"
              style={{ width: '36px', height: '36px' }}
              onClick={() => setActiveImage(null)}
            >
              <FaTimes size={16} />
            </button>
            <div style={{ height: '350px' }}>
              <img 
                src={activeImage.src} 
                alt={activeImage.title} 
                className="w-100 h-100 object-fit-cover"
              />
            </div>
            <div className="p-4">
              <span className="badge bg-teal text-white px-3 py-1 small mb-2">{activeImage.category}</span>
              <h4 className="fw-bold text-dark mb-2">{activeImage.title}</h4>
              <p className="text-muted small mb-0">{activeImage.description}</p>
            </div>
          </div>
        </div>
      )}

    </main>
  );
};

export default ImageGallery;